/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOtherAssets = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 2H2v20h20V2h-1zm1 18V4h16v10.413l-3.26-3.586-.688-.756-.74.704L5.6 20zm11.948-7.071L20 17.387V20H8.505zM6.5 9H18V7H6.5zm0 2h6.427l-2.074 2H6.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOtherAssets as OtherAssets };
